import { Gender, JobStatus } from '@/types/common';

// 判断是否开发环境
const isDev = process.env.NODE_ENV === 'development';

// 开发环境使用本地路径，生产环境使用OSS路径
export const OSS_BASE = isDev ? '' : 'https://mini-gsteps-resource.g-links.com.cn/saas-admin';

// 图片基础路径
export const IMAGE_OSS_BASE = `${OSS_BASE}/images`;

export const DEFAULT_AVATAR = `${OSS_BASE}/images/default_avatar.png`;

export const DEFAULT_PAGE_SIZE = 20; // 默认每页显示的记录数

// 存储key管理
export const STORAGE_KEY = {
  loginToken: 'login_token',
  studioId: 'welcomeSelectedStudioId', // 当前选中的门店ID
};

// 性别选项
export const GENDER_OPTIONS = [
  // { label: '未知', value: Gender.UNKNOWN },
  { label: '女', value: Gender.FEMALE },
  { label: '男', value: Gender.MALE },
];

// 全兼职选项
export const JOB_OPTIONS = [
  { label: '全职', value: JobStatus.FULL_TIME },
  { label: '兼职', value: JobStatus.PART_TIME },
];
